import * as Yup from 'yup';
import { createSchema } from '../../../../../../../../utils/formUtils';

export type GetDiagnosticsDialogFields = { location: string };

export const WebhookDomain = 'webhook.site';

const ValidGetDiagnosticsUrlRegularExpression = `^(https://)?(www.)?${WebhookDomain}([-a-zA-Z0-9()@:%_+.~#?&//=]*)`;

export const validationSchema = createSchema<GetDiagnosticsDialogFields>({
  location: Yup.string()
    .typeError('Upload URL must be a string')
    .required('Upload URL is required')
    .matches(new RegExp(ValidGetDiagnosticsUrlRegularExpression), 'Unsupported URL'),
});
